function buildSections(data) {
  var contentWrapper = $('#fit-guide');
  contentWrapper.children('.fit-guide__content').empty();
  var wrappingDiv = $('<div/>', {
    "id": "",
    "class": "fit-guide__content",
  }).appendTo(contentWrapper);
  for (var i = 0; i < data.length; i++) {
    var s = data[i];
    var collapsed;
    if (i == 0) {
      collapsed = "";
    } else {
      collapsed = "collapsed";
    }
    var sectionWrapper = $('<div />', {
      "class": "fit-guide__section " + collapsed
    }).appendTo(wrappingDiv);
    var title = $('<h6 />', {
      "text": s.section.title
    }).appendTo(sectionWrapper);
    var toggle = $('<span />', {
      "class": "toggle"
    }).appendTo(sectionWrapper);
    switch (s.section.type) {
      case "table":
        sectionWrapper.append(buildTable(s.section.header, s.section.rows));
        break;
      case "twoCol":
        sectionWrapper.append(buildTwoCol(s.section.columns));
        break;
      case "singleCol":
        sectionWrapper.append(buildSingleCol(s.section.columns));
        break;
      case "fullCol":
        sectionWrapper.append(buildFullCol(s.section.columns));
        break;
    }
  }

  wrappingDiv.append(buildNeedHelp());

  return false;
}

function urlify(string) {
  str = string.replace(/\s+/g, '-').toLowerCase();
  return str;
}

function buildTable(headers, rows) {
  var colWrapper = $('<div />', {
    "class": "fg-row"
  });
  var btnGroup = $('<div />', {
    "id": "measurement-switch",
    "class": "btn-group",
    "role": "group",
    "aria-label": "ms"
  }).appendTo(colWrapper);
  var inButton = $('<button />', {
    "type": "button",
    "class": "btn btn-active",
    "text": "In",
    "data-unit": 'in'
  }).appendTo(btnGroup);
  var cmButton = $('<button />', {
    "type": "button",
    "class": "btn",
    "text": "cm",
    "data-unit": 'cm'
  }).appendTo(btnGroup);
  var table = $('<table />', {
    "id": "tbl",
    "class": "",
    "data-unit": "in"
  }).appendTo(colWrapper);
  var tableHeader = $('<thead />').appendTo(table);
  var tableBody = $('<tbody />').appendTo(table);
  var tableHeaderRow = $('<tr />').appendTo(tableHeader);
  for (var h = 0; h < headers.length; h++) {
    var header = headers[h];
    var th = $('<th />', {
      "scope": "col",
      "text": header
    }).appendTo(tableHeaderRow);
  }
  for (var r = 0; r < rows.length; r++) {
    var row = rows[r];
    var tr = $('<tr />').appendTo(tableBody);
    for (var c = 0; c < row.length; c++) {
      var col = row[c];
      var td = $('<td />', {
        "text": col,
        "data-index": c
      }).appendTo(tr);
    }
  }
  return colWrapper;
}

function buildTwoCol(columns) {
  var colWrapper = $('<div />', {
    "class": "fg-row"
  });

  for (var c = 0; c < columns.length; c++) {
    var col       = columns[c];
    var singleCol = $('<div />', { "class": "fg-two-col"}).appendTo(colWrapper);
    var imgWrapp  = $('<div />', { "class": "fg-img-wrapper" }).appendTo(singleCol);
    var img       = $('<img />', { "src": col[0].img }).appendTo(imgWrapp);
    var title     = $('<span />', { "text": col[0].title, "class": "title" }).appendTo(singleCol);
    var body      = $('<p />', { "text": col[0].body }).appendTo(singleCol);
  }
  return colWrapper;
}

function buildSingleCol(columns) {
  var colWrapper = $('<div />', {
    "class": "fg-row"
  });
  var column = $('<div />', {
    "class": "fg-single-col"
  }).appendTo(colWrapper);
  for (var c = 0; c < columns.length; c++) {
    var col = columns[c];
    if (c == 0) {
      var img = $('<img />', { "src": col[0].img }).appendTo(column);
    } else {
      if (c == 1) {
        var copyClear = $('<div />', { "class": "right-copy" }).appendTo(column);
      }
      var body = $('<p />', { "text": col[0].body }).appendTo(copyClear);
      var title = $('<span />', { "text": col[0].title }).prependTo(body);
    }
  }
  return colWrapper;
}

function buildFullCol(columns) {
  for (var c = 0; c < columns.length; c++) {
    var col = columns[c];

    var colWrapper = $('<div />', {
      "class": "fg-row"
    });
    var column = $('<div />', {
      "class": "fg-full-col"
    }).appendTo(colWrapper);

    var body = $('<p />', { "text": col[0].body }).appendTo(column);
    var title = $('<span />', { "class": "title", "text": col[0].title }).prependTo(column);
  }

  return colWrapper;
}

function buildNeedHelp() {
  var html = "<p>If you'd like more detailed guidance, please visit our detailed fit guide page or email us at <a href='mailto:team@bluffworks.com'>team@bluffworks.com</a>.</p>"
  
  var sectionWrapper = $('<div />', {
    "class": "fit-guide__section collapsed"
  });

  var title = $('<h6 />', {
    "text": 'Need Help?'
  }).appendTo(sectionWrapper);

  var toggle = $('<span />', {
    "class": "toggle"
  }).appendTo(sectionWrapper);

  var colWrapper = $('<div />', {
    "class": "fg-row"
  }).appendTo(sectionWrapper);

  var column = $('<div />', {
    "class": "fg-full-col need-help",
    "html": html
  }).appendTo(colWrapper);

  return sectionWrapper;
}

function changeCategory(data) {
  var catLabel  = $('.fit-guide__selected-option .category');
  var prodLabel = $('.fit-guide__selected-option .product');
  var mensLi    = $('li#mensOptions');
  var womensLi  = $('li#womensOptions');

  catLabel.text(data.category);
  prodLabel.text(data.product);

  if (catLabel.text().includes('Men\'s')) {
    mensLi.addClass('active');
    womensLi.removeClass('active').children('ul').slideUp(200);
  }

  if (catLabel.text().includes('Women\'s')) {
    womensLi.addClass('active');
    mensLi.removeClass('active').children('ul').slideUp(200);
  }
}

function fitGuideInit(product) {
  changeCategory(product);
  buildSections(product.sections);
}

$(document).on('click', '.fit-guide__section span.toggle, .fit-guide__section h6', function(event) {
  var content = $(this).parent('.fit-guide__section');
  content.stop().toggleClass('collapsed');
});

$(document).on('click', '.fit-guide__selected-option, #fit-guide__options li a', function(event) {
  var options = $('#fit-guide__options');
  options.stop().slideToggle(200);
});

$(document).on('click', '#fit-guide__options a', function(event) {
  fitGuideInit(eval($(this).data('option')));
});

$(document).on('click', '#fit-guide__options span', function(event) {
  $(this).stop().next('ul').stop().slideToggle(200);
  $(this).parent('li').stop().toggleClass('active');
});

$(document).on('click', '#measurement-switch button', function(event) {
  if (!$(this).hasClass('btn-active')) {
    $(this).stop().toggleClass('btn-active');
    $(this).siblings('button').stop().toggleClass('btn-active');
    
    var tbl = $(this).parent().parent().find('table');
    var tds = tbl.find('tbody').find('td');

    tds.each(function() {
      if ($(this).data('index') > 1) {
        var td      = $(this);
        var text    = $(this).text();
        var numbers = text.match(/[\d\.]+/g);

        if (numbers != null) {
          for (var i = 0; i < numbers.length; i++) {
            var num = parseFloat(numbers[i]);

            if (tbl.data('unit') == 'in') {
              var text = text.replace(num, Math.round((num * 2.54) * 10) / 10 );
            } else {
              var text = text.replace(num, Math.round((num * 0.39370079) * 10) / 10);
            }
          }
          td.text(text);
        }
      }
    });
    
    tbl.data('unit', $(this).data('unit'));
  }
});